angular.module('am4').controller('editNicknameCtrl', function($scope) {
    $scope.oldNickame = angular.copy($scope.nickname);
});



// WEBPACK FOOTER //
// ./src/app/controllers/editNicknameCtrl.js